import { render, staticRenderFns } from "./UserDetailForm.vue?vue&type=template&id=e2e75854&scoped=true"
import script from "./UserDetailForm.vue?vue&type=script&lang=js"
export * from "./UserDetailForm.vue?vue&type=script&lang=js"
import style0 from "./UserDetailForm.vue?vue&type=style&index=0&id=e2e75854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e75854",
  null
  
)

export default component.exports